import { makeStyles } from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import FileTableCell from "./FileTableCell";
import {
  selLibraryListViewSorter,
  sortListViewBy,
} from "./../slice/librarySlice";

import * as R from "ramda";

const sortByPropTitle = (prop, asc) =>
  asc
    ? R.sortWith([R.ascend(R.compose(R.identity, R.pathOr("N/A", prop)))])
    : R.sortWith([R.descend(R.compose(R.identity, R.pathOr("N/A", prop)))]);

const FileTable = (props) => {
  const { items, handleDrawer } = props;
  const { folders = [], files = [], current } = items;

  const dispatch = useDispatch();
  const sorter = useSelector(selLibraryListViewSorter);
  const listSort = sorter.sort;
  const listasc = sorter.asc;
  const listPath = sorter.path;

  const allItems = [...folders, ...files];
  const filteredItems = sortByPropTitle(listPath, listasc)(allItems);

  function sortBy(by) {
    console.log(by);
    dispatch(sortListViewBy(by));
  }

  return (
    <div className="table-responsive-material">
      <table className="default-table table-unbordered table table-sm table-hover">
        <thead className="th-border-b">
          <tr>
            <th></th>
            <HeaderTH
              name={"name"}
              path={["title"]}
              title={"Name"}
              onClick={sortBy}
              sorter={listSort}
              asc={listasc}
            />
            <HeaderTH
              name={"is_folder"}
              path={["is_folder"]}
              title={"Type"}
              onClick={sortBy}
              sorter={listSort}
              asc={listasc}
            />
            <th>Extension</th>
            {/* <HeaderTH
              name={"extension"}
              path={["extension"]}
              title={"Extension"}
              onClick={sortBy}
              sorter={listSort}
              asc={listasc}
            /> */}
            <HeaderTH
              name={"author"}
              path={["created_by", "known_as"]}
              title={"Author"}
              onClick={sortBy}
              sorter={listSort}
              asc={listasc}
            />
            <th>Version</th>
            {/* <HeaderTH
              name={["version"]}
              title={"Version"}
              onClick={sortBy}
              sorter={listSort}
              asc={listasc}
            /> */}
            <HeaderTH
              name={"Date modified"}
              path={["updated_time"]}
              title={"Date modified"}
              onClick={sortBy}
              sorter={listSort}
              asc={listasc}
            />

            <th></th>
            <th />
          </tr>
        </thead>
        <tbody>
          {filteredItems.map((item) => {
            return (
              <FileTableCell
                handleDrawer={handleDrawer}
                key={item.id}
                content={item}
                current={current}
              />
            );
          })}
          {/* {folders.map((folder) => {
            return (
              <FileTableCell
                handleDrawer={handleDrawer}
                key={folder.id}
                content={folder}
                current={current}
              />
            );
          })}
          {files.map((file) => {
            return (
              <FileTableCell
                handleDrawer={handleDrawer}
                key={file.id}
                content={file}
                current={current}
              />
            );
          })} */}
        </tbody>
      </table>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  headTitle: {
    fontWeight: "bold",
  },
}));

const HeaderTH = (props) => {
  const classes = useStyles();
  const { title, name, sorter, asc, onClick, path = [""] } = props;
  const showSort = name === sorter;

  function onHeaderClick() {
    return onClick([name, path]);
  }
  return (
    <th onClick={onHeaderClick} style={{ cursor: "pointer" }}>
      <div className={showSort ? classes.headTitle : ""}>
        {title}
        {!showSort ? (
          ""
        ) : asc ? (
          <i className={`ml-2 zmdi zmdi-long-arrow-up`} />
        ) : (
          <i className={`ml-2 zmdi zmdi-long-arrow-down`} />
        )}
      </div>
    </th>
  );
};

export default FileTable;
